import clsx from 'clsx'
import { useMemo } from 'react'
import { Filter, FilterChangeFn, ProductListItemVariant } from './types'
import { useTranslation } from 'react-i18next'
import { ProductsConnectionEdge } from '@/eshop/gql/graphql'
import { useK2Setup } from '@/eshop/hooks/useK2Setup'

interface Props {
    variants: ProductsConnectionEdge[]
    filter: Filter
    onFilterChange: FilterChangeFn
}
export function ProductListItemFilter({
    variants,
    filter,
    onFilterChange,
}: Props) {
    const { t } = useTranslation()
    const k2 = useK2Setup()
    type Option = [label: string, value: string | null]

    // Manufaturer Badges on top
    const manufacturerOptions: Option[] = useMemo(() => {
        const temp = variants
            .map(
                (v) =>
                    v.node.productLangItems?.find(
                        (pl) => (pl.languageId = k2.languageId)
                    )
            )
            .filter((x) => !!x)
            .reduce(
                (acc, pl) => {
                    const manufacturer =
                        pl?.brandName || t('eshop.productlist.other')
                    if (!acc[manufacturer]) {
                        acc[manufacturer] = 0
                    }
                    acc[manufacturer] += 1
                    return acc
                },
                {} as Record<string, number>
            )

        return [
            [t('eshop.productlist.allManufacturers'), null],
            ...(Object.entries(temp).map(([k, v]) => [
                `${k} (${v})`,
                k,
            ]) as Option[]),
        ]
    }, [variants, t, k2.languageId])

    return (
        <div className="flex gap-2 flex-wrap">
            {manufacturerOptions.map(([label, value], i) => (
                <div
                    className={clsx(
                        'px-2 py-1 rounded-lg text-sm',
                        filter.manufacturer === value
                            ? 'bg-secondary font-bold text-white'
                            : 'bg-gray-light cursor-pointer'
                    )}
                    key={value}
                    onClick={onFilterChange('manufacturer', value)}
                >
                    {label}
                </div>
            ))}
        </div>
    )
}
